import React, { useEffect } from 'react';
import ColGroup from './colgroup';
import cssClasses from './header.css';

const Header = (props) => {
    const { columns, primaryColumnWidthValues, columnWidthList, updateColumnWidthList, startColumnResize } = props;

    useEffect(() => {
        // console.log(`header rendering`);
        if (!columnWidthList) {
            let ColumnWidthList = {};
            const columnElements = document.getElementById('header-row').childNodes;
            columnElements.forEach((column, idx) => {
                ColumnWidthList[column.getAttribute('data-column-id')] = column.offsetWidth;
            });
            updateColumnWidthList(ColumnWidthList);
        }
    }, [columnWidthList]);


    const tableSize = localStorage.getItem('tablesize');
    return <table size={tableSize || 'medium'} aria-label="Quick Coding Table" className={cssClasses.table}>
        <ColGroup columns={columns} columnWidthValues={!columnWidthList ? primaryColumnWidthValues : columnWidthList}></ColGroup>
        <thead className={cssClasses.thead}>
            <tr id='header-row' className={cssClasses.tr}>
                {columns.map((column, i) => {
                    return (
                        <th key={i} data-column-id={column.id} data-index={i} className={cssClasses.th}>
                            {typeof column.title === 'string' ? column.title : column.title()}
                            {i + 1 !== columns.length ? <div className={cssClasses.resizeColumn} onMouseDown={(e) => startColumnResize(e, column)}></div> : ''}
                        </th>
                    );
                })}
            </tr>
        </thead>
    </table>
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/DataTable/Header/header.js